import { CloudOff } from 'lucide-react';
import { useConnectionStatus } from '@/state/connectionStatus';

/**
 * Top-bar chip for READ connectivity (mirrors PersistenceIndicator, which
 * covers writes). Hidden while online; shows "Reconnecting to server…" while a
 * live view fetch is failing, so an empty screen is never mistaken for real,
 * wiped data.
 */
export default function ConnectionIndicator() {
  const status = useConnectionStatus((s) => s.status);
  if (status === 'online') return null;
  return (
    <div
      className="flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs whitespace-nowrap border-orange/50 bg-orange/10 text-orange"
      data-testid="connection-indicator"
      data-status="reconnecting"
      role="status"
      aria-live="polite"
      title="Reconnecting to server…"
    >
      <CloudOff size={13} className="shrink-0" />
      <span>Reconnecting to server…</span>
    </div>
  );
}
